import { createRoute } from './routeUtils'

import { MoySkladAppScreenParams } from '../types/moySkladAppTypes'
import { MoySkladAppType } from '../server/mpsklad_common/MoySkladAppType'

export const moySkladAppRouteBase = '/moySkladApp'

const moySkladAppRoute =
  createRoute<typeof MoySkladAppType, MoySkladAppScreenParams>(
    {appType: MoySkladAppType},
    moySkladAppRouteBase)`/${'appType'}`

export const moySkladAppRoutes = {
  MoySkladApp: moySkladAppRoute,
  /** Only for backwards compatibility */
  MoySkladAppOld: moySkladAppRouteBase
} as const